import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import InputMask from 'react-input-mask'

import slugify from 'react-slugify'
import Context from '../../context'
import { ClearStringNumber } from '../../helpers/ClearStringNumber'
import { checkEmail, getClassificationList, selectResponsibleList } from '../../services/ClubeApi'
import SelectTags from '../SelectTags'
import SlugSeoDescription from '../SlugSeoDescription'

function CompanyForm({ editing, formType, checkValue, checkIsRed }) {
  const {
    responsibleList,
    setResponsibleList,
    formObject,
    setFormObject,
    setOpenToast,
    showTags,
    setShowTags,
    classificationList,
    setClassificationList,
    citys,
    showCitys
  } = useContext(Context)

  const [warningClass, setWarningClass] = useState({
    dash: '',
    validate: ''
  })

  console.log('formObject dentro do company form', formObject)

  useEffect(() => {
    const getResponsibleList = async () => {
      return selectResponsibleList()
    }

    const getListClassification = async () => {
      return getClassificationList()
    }

    if (formType !== 'unity') {
      getResponsibleList().then(r => {
        setResponsibleList(r)
        setShowTags(true)
      })

      getListClassification().then(r => {
        setClassificationList(r)
      })
    }
  }, [])

  useEffect(() => {
    const seoDescription = `Saiba mais sobre o ${formObject.fantasyName} e aproveite os descontos exclusivos para assinantes do Clube Gazeta do Povo!`
    setFormObject({ ...formObject, seoDescription })
  }, [formObject.fantasyName])

  const checkAvailableEmail = (email, type) => {
    if (email.length > 0) {
      checkEmail(email).then(r => {
        const newObj = { ...warningClass }
        if (!r) {
          newObj[type] = 'clube-border-danger'
          setWarningClass({ ...newObj })
          setOpenToast({
            open: true,
            message: 'E-mail já cadastrado em nosso sistema, favor inserir outro.',
            type: 'error'
          })
        } else {
          newObj[type] = ''
          setWarningClass({ ...newObj })
          setOpenToast({
            open: false,
            message: '',
            type: 'error'
          })
        }
      })
    }
    const key = type === 'dash' ? 'userCompanyEmail' : 'unityCompanyEmail'
    checkValue(key, email)
  }

  const setSlugFromName = () => {
    setFormObject({
      ...formObject,
      slug: slugify(`${formObject.fantasyName}`)
    })
    checkValue('fantasyName', formObject.fantasyName)
  }

  return (
    <>
      {formObject.isUnity ? <h5>Dados da Unidade</h5> : <h5>Dados do Parceiro</h5>}
      {showTags && (
        <div className="row">
          <SelectTags />
        </div>
      )}
      <div className="row">
        <div className="form-group col-6">
          <InputMask
            mask="99.999.999/9999-99"
            value={formObject.cnpj || ''}
            onChange={e =>
              setFormObject({
                ...formObject,
                cnpj: ClearStringNumber(e.target.value)
              })
            }
            type="text"
            className={`form-control ${checkIsRed('cnpj') && 'clube-border-danger'}`}
            placeholder="CNPJ"
            onBlur={e => checkValue('cnpj', e.target.value)}
          />
        </div>
        <div className="form-group col-6">
          <input
            value={formObject.fantasyName || ''}
            onChange={e => setFormObject({ ...formObject, fantasyName: e.target.value })}
            onBlur={setSlugFromName}
            type="text"
            className={`form-control ${checkIsRed('fantasyName') && 'clube-border-danger'}`}
            placeholder="Nome Fantasia"
          />
        </div>
        <div className="form-group col-12">
          <input
            value={formObject.corporateName || ''}
            onChange={e => setFormObject({ ...formObject, corporateName: e.target.value })}
            type="text"
            className={`form-control ${checkIsRed('corporateName') && 'clube-border-danger'}`}
            placeholder="Razão Social"
            onBlur={e => checkValue('corporateName', e.target.value)}
          />
        </div>
        <div className=" col-12">
          <SlugSeoDescription editing={editing} checkIsRed={checkIsRed} checkValue={checkValue} />
        </div>

        {responsibleList && responsibleList.length > 0 && (
          <div className="col-6 d-flex flex-row">
            <label htmlFor="responsibleSelect" className="padding-bottom-label">
              Executivo Responsável
            </label>
            <select
              className="custom-select"
              id="responsibleSelect"
              onChange={e =>
                setFormObject({
                  ...formObject,
                  responsibleUser: e.target.value
                })
              }
              defaultValue={`${formObject.responsibleUser}`}
            >
              {responsibleList.map(item => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {formObject.isUnity && (
          <div className="form-group col-6">
            <input
              value={formObject.unityCompanyEmail || ''}
              onChange={e =>
                setFormObject({
                  ...formObject,
                  unityCompanyEmail: e.target.value
                })
              }
              type="text"
              className="form-control"
              placeholder="E-mail do Validador"
            />
          </div>
        )}

        {formType === 'partner' && (
          <>
            <div className="form-group col-6">
              <input
                value={formObject.userCompanyEmail || ''}
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    userCompanyEmail: e.target.value
                  })
                }
                type="text"
                className={`form-control ${warningClass.dash} ${
                  checkIsRed('userCompanyEmail') && 'clube-border-danger'
                }`}
                placeholder="E-mail para a Dashboard"
                onBlur={e => {
                  checkAvailableEmail(e.target.value, 'dash')
                }}
              />
            </div>

            <div className="col-6">
              <div className="form-check form-group">
                <input
                  id="isUnity"
                  className="form-check-input"
                  type="checkbox"
                  checked={formObject.isUnity}
                  onChange={() =>
                    setFormObject({
                      ...formObject,
                      isUnity: !formObject.isUnity
                    })
                  }
                />
                <label htmlFor="isUnity" className="form-check-label padding-bottom-label">
                  A Matriz é uma unidade
                </label>
              </div>
            </div>

            <div className="col-6">
              <div className="form-check form-group">
                <input
                  id="heroSparkAccess"
                  className="form-check-input"
                  type="checkbox"
                  checked={formObject.herosparkAccess}
                  onChange={() =>
                    setFormObject({
                      ...formObject,
                      herosparkAccess: !formObject.herosparkAccess
                    })
                  }
                />
                <label htmlFor="heroSparkAccess" className="form-check-label padding-bottom-label">
                  Acesso a EAD
                </label>
              </div>
            </div>
          </>
        )}

        {classificationList && classificationList.length > 0 && (
          <div className="col-6 d-flex flex-row">
            <label htmlFor="partnerClassification" className="padding-bottom-label">
              Classificação do Parceiro
            </label>
            <select
              className="custom-select"
              id="partnerClassification"
              onChange={e =>
                setFormObject({
                  ...formObject,
                  partnerClassification: e.target.value
                })
              }
              defaultValue={`${formObject.partnerClassification}`}
            >
              <option value={0}>Selecione</option>
              {classificationList.map(item => (
                <option key={item.id} value={item.id}>
                  {item.description}
                </option>
              ))}
            </select>
          </div>
        )}
        {showCitys && (
          <div className="col-6 d-flex flex-row">
            <label htmlFor="partnerClassification" className="padding-bottom-label">
              Cidade do Parceiro
            </label>
            <select
              className="custom-select"
              id="partnerCitysMoviesId"
              onChange={e =>
                setFormObject({
                  ...formObject,
                  partnerCitysMoviesId: e.target.value
                })
              }
              defaultValue={`${formObject.partnerCitysMoviesId}`}
            >
              <option value={0}>Selecione</option>
              {citys.map(item => (
                <option key={item.id} value={item.id}>
                  {item.city}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </>
  )
}

CompanyForm.defaultProps = {
  formType: 'partner',
  editing: false,
  checkValue: () => {},
  checkIsRed: () => {}
}

CompanyForm.propTypes = {
  formType: PropTypes.string,
  editing: PropTypes.bool,
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default CompanyForm
